import name from './name';
import numberOfProducts from './numberOfProducts';
import { actions } from './actions';

export default [name, numberOfProducts, actions];
